



































import { Component, Prop } from "vue-property-decorator";

import Vue from "vue";
import { SurveyElementCore } from "survey-core";
@Component
export class TitleContent extends Vue {
  @Prop() element: any;
  @Prop() css: any;

  get cssClasses() {
    return (this.element.isPanel ? this.element.cssClasses.panel : this.element.cssClasses) || {};
  }

}
Vue.component("survey-element-title-content", TitleContent);
export default TitleContent;
